import { forwardRef } from "react";
import Box, { BoxProps } from "@mui/material/Box";

export const MuiBox = forwardRef<HTMLDivElement, BoxProps>((props, ref) => {
  return <Box {...props} ref={ref} />;
});
